class ReplacementNeedleGuide extends HTMLElement {
  /** @type {AbortController | undefined} */
  #controller;

  connectedCallback() {
    this.#controller?.abort();
    this.#controller = new AbortController();

    this.querySelectorAll('[data-needle-toggle]').forEach((toggle) => {
      if (!(toggle instanceof HTMLButtonElement)) return;

      this.#setExpanded(toggle, toggle.dataset.initialExpanded === 'true');
      toggle.addEventListener('click', this.#handleToggle, { signal: this.#controller.signal });
    });

    this.dataset.enhanced = 'true';
  }

  disconnectedCallback() {
    this.#controller?.abort();
    this.#controller = undefined;
    delete this.dataset.enhanced;
  }

  /** @param {MouseEvent} event */
  #handleToggle = (event) => {
    const toggle = event.currentTarget;
    if (!(toggle instanceof HTMLButtonElement)) return;

    this.#setExpanded(toggle, toggle.getAttribute('aria-expanded') !== 'true');
  };

  /**
   * @param {HTMLButtonElement} toggle
   * @param {boolean} expanded
   */
  #setExpanded(toggle, expanded) {
    const group = toggle.closest('[data-needle-group]');
    const panel = group?.querySelector('[data-needle-panel]');
    if (!(panel instanceof HTMLElement)) return;

    toggle.setAttribute('aria-expanded', String(expanded));
    panel.toggleAttribute('inert', !expanded);
    panel.setAttribute('aria-hidden', String(!expanded));
    group.dataset.expanded = String(expanded);
  }
}

if (!customElements.get('replacement-needle-guide')) {
  customElements.define('replacement-needle-guide', ReplacementNeedleGuide);
}
